import React from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    EmailField,
    FunctionField,
    List,
    ReferenceField,
    TextField,
} from 'react-admin';
import { FullNameField, DoctorReferenceField, PatientReferenceField } from "../../misc/customFields";

export const SharingList = props => {
    return (
        <div>
            <List {...props} >
                <Datagrid>
                    <TextField
                        source="patient.id"
                        label="Patient ID"
                    />
                    <PatientReferenceField
                        label="Patient"
                        source="patient.id"
                        sortBy="patient"
                    />
                    <EmailField
                        source="patient.email"
                        label="Patient Email"
                    />
                    <DoctorReferenceField
                        label="Clinician Owner"
                        source="owner"
                    />
                    <DoctorReferenceField
                        label="Shared With"
                        source="shared_doctor"
                    />
                    <DateField
                        label="Date of Sharing"
                        source="start_date"
                        showTime
                    />
                    <TextField
                        source="sharing_status"
                        label="Sharing Status"
                    />
                </Datagrid>
            </List>
        </div>
    )
}
